import DOMPurifyFactory from 'dompurify';
import { marked } from 'marked';
import React from 'react';

import { MarkdownContent } from '~/components/AIInsightsSidebar/AIInsightsSidebar.styles';

import { Block } from './blockTypes';
import SimpleBarChart from './SimpleBarChart';
import SimpleColumnChart from './SimpleColumnChart';
import SimpleFunnelChart from './SimpleFunnelChart';
import SimpleLineChart from './SimpleLineChart';
import SimplePieChart from './SimplePieChart';

const DOMPurify = DOMPurifyFactory(window);

interface Props {
  block: Block;
}

const UIBlock = ({ block }: Props) => {
  switch (block.type) {
    case 'text':
      return (
        <MarkdownContent
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(marked.parse(block.content) as string),
          }}
        />
      );
    case 'line_chart':
      return <SimpleLineChart block={block} />;
    case 'bar_chart':
      return <SimpleBarChart block={block} />;
    case 'pie_chart':
      return <SimplePieChart block={block} />;
    case 'column_chart':
      return <SimpleColumnChart block={block} />;
    case 'funnel_chart':
      return <SimpleFunnelChart block={block} />;
  }
};

export { UIBlock };
